<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle1">Acknowledgements</h2>
<p class="noindent">This presentation of ILAF operations during ILDF Operation HOREV benefits from materials that have been gathered over a timeframe of more than 20 years from national archives and personal collections. The author thanks Oded Abarbanell, Haggai Agmon, Daniel Arber, Rudy Augarten, Zvi Avidror, Israel Ben-Shachar, Yeshayahu Bodilewsky, Judah Borovik, Jules Cuburnek, Brian Cull, Yoav Efrati, Eli Eyal, Ron Feldman, Seymour Feldman, Michel Finegood, Aaron Finkel, Leon Frankel, Shaya Gazit, Udi Gazit, Josef Gideoni, Johnny Harris, Leif Hellstrom, Moti Hod, Arie Jacoby, Eddy Kaplansky, Shabtai Katz, Josef Keidar, Samuel Laron, Lou Lenart, Zvi Lavon, George Lichter, Gideon Lichtman, Hugo Marom, Ariel Naor, Nathan Navot, David Nicolle, Josef Ofer, Benjamin Peled, Moshe Peled, Yoram Peled, Asher Roth, Meir Ruff, Boris Senior, Daniel Shapira, Smoky Simon, Pessach Tal, Yoash Tsiddon, Ran Yahalom and Zahik Yavneh, as well as ILDA, ILPO and UKNA for documents, memories and photos. All presented photos originated from collections of the aforementioned.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknowledgements.vue?20c188b2